<template>
  <div class="content-box">
    <div class="no-menu-inner">
      <div class="pt-create-account">
        <el-button type="text" icon="el-icon-arrow-left" class="back-btn" @click="goToDestination">{{
          $t('propTrade.button.backToClientPortal')
        }}</el-button>
        <div class="header mb-4">
          <Banner immediateShowContent />
        </div>
        <ChooseAccount
          v-show="currentStep === CHOOSE_ACCOUNT"
          @redirectCurrentPage="redirectCurrentPage"
          @changeChooseAccountData="changeChooseAccountData"
        />
        <SubscriptionDetail
          v-if="currentStep === SUBSCRIPTION_DETAIL"
          :chooseAccountData="chooseAccountData"
          @redirectCurrentPage="redirectCurrentPage"
        />
        <SubscriptionCreditCard
          v-if="currentStep === SUBSCRIPTION_CREDIT_CARD"
          :chooseAccountData="chooseAccountData"
          :additionalData="additionalData"
          @redirectCurrentPage="redirectCurrentPage"
        />
        <SubscriptionCryptoQrCode v-if="currentStep === CRYPTO_QRCODE" :additionalData="additionalData" />
      </div>
    </div>
  </div>
</template>
<script>
import ChooseAccount from '../components/createAccount/ChooseAccount.vue';
import SubscriptionDetail from '../components/createAccount/SubscriptionDetail.vue';
import SubscriptionCreditCard from '../components/createAccount/SubscriptionCreditCard.vue';
import SubscriptionCryptoQrCode from '../components/createAccount/SubscriptionCryptoQrcode.vue';
import Banner from '@/components/propTrading/components/Banner.vue';
const CHOOSE_ACCOUNT = 'chooseAccount';
const SUBSCRIPTION_DETAIL = 'subscriptionDetail';
const SUBSCRIPTION_CREDIT_CARD = 'subscriptionCreditCard';
const CRYPTO_QRCODE = 'cryptoQrcode';
export default {
  name: 'PropTradingCreateAccount',
  components: { ChooseAccount, SubscriptionDetail, SubscriptionCreditCard, SubscriptionCryptoQrCode, Banner },
  data() {
    return {
      CHOOSE_ACCOUNT,
      SUBSCRIPTION_DETAIL,
      SUBSCRIPTION_CREDIT_CARD,
      CRYPTO_QRCODE,
      currentStep: 'chooseAccount',
      chooseAccountData: {},
      additionalData: null
    };
  },
  watch: {
    currentStep(val) {
      this.scrollToTop();
    }
  },
  methods: {
    scrollToTop() {
      this.$nextTick(() => {
        document.getElementById('elMain').scrollTop = 0;
      });
    },
    goToDestination() {
      this.$router.push({ name: 'home' });
    },
    redirectCurrentPage(data, additionalData) {
      this.additionalData = additionalData;
      this.currentStep = data;
    },
    changeChooseAccountData(data) {
      this.chooseAccountData = data;
    }
  }
};
</script>
<style lang="scss" scoped>
.back-btn {
  color: $primary-dark-blue;
  border: none;
  padding: 0;
  font-size: 14px;
  margin-bottom: 24px;
  &:hover,
  &:focus {
    color: $primary-dark-blue;
    background-color: transparent;
  }
}
/deep/.card {
  border-radius: 16px;
  padding: 28px 21px;
  margin-top: 16px;
  margin-bottom: 60px;
  background-color: $white;
}

/deep/.el-form-item {
  margin-bottom: 22px;
}
/deep/.el-form-item__label {
  margin-bottom: 4px;
}
/deep/.el-input.is-disabled .el-select__caret {
  display: none;
}
</style>
